import TextField from "@mui/material/TextField";
import type { JobRunSettingsProps } from "@/features/job/job-run/jobRun.types";
import { toJobRunInputWith, toJobRunText } from "@/features/job/job-run/jobRun.utils";

/** Pull eStore stock reports' settings: at most how many new files to pull (empty for all). */
export const JobRunPullEstoreInventory = (props: JobRunSettingsProps) => {
  const { input, onChange } = props;

  const handleChange = (text: string) => {
    let value: number | string = "";
    if (text !== "") value = Number(text);
    const next = toJobRunInputWith(input, "limit", value);
    onChange(next);
  };

  return (
    <TextField
      fullWidth
      helperText="Leave empty to pull every new file."
      label="Most files (optional)"
      onChange={(event) => handleChange(event.target.value)}
      size="small"
      slotProps={{ htmlInput: { min: 1 } }}
      type="number"
      value={toJobRunText(input, "limit")}
    />
  );
};
